/**
 * Phone shell decisions that do not belong in a component.
 *
 * PHONE_SHELL_MAX_PX is the only switch for "mobile for now". Raising it, or
 * dropping the viewport check in usePhoneShellEnabled, is how the same chrome
 * turns on for desktop later. Desktop above this width is unchanged.
 */
export const PHONE_SHELL_MAX_PX = 1200;

export function filterGamesByTeamQuery(games = [], query = "") {
  const q = String(query || "").trim().toLowerCase();
  if (!q || !Array.isArray(games)) return Array.isArray(games) ? games : [];
  return games.filter((game) => {
    const home = String(game?.home_team || "").toLowerCase();
    const away = String(game?.away_team || "").toLowerCase();
    return home.includes(q) || away.includes(q);
  });
}

/** Slip shape in Redux is an array of leg arrays, one per builder tab. */
export function slipSelectionCount(checkInd) {
  if (!Array.isArray(checkInd)) return 0;
  return checkInd.reduce(
    (total, row) => total + (Array.isArray(row) ? row.length : 0),
    0
  );
}

export function formatBadgeCount(count) {
  const n = Number(count);
  if (!Number.isFinite(n) || n <= 0) return "";
  return n > 99 ? "99+" : String(n);
}

/**
 * Filter the left-nav tree by a sport search. A matching parent keeps its
 * children. A matching child keeps its parent, expanded, with only the matches.
 */
export function filterNavItems(items = [], query = "", labelOf = (item) => item?.labelText) {
  const q = String(query || "").trim().toLowerCase();
  if (!q) return items;
  return items.reduce((acc, item) => {
    const label = String(labelOf(item) || "").toLowerCase();
    const subs = Array.isArray(item?.subMenu) ? item.subMenu : null;
    if (!subs) {
      if (label.includes(q)) acc.push(item);
      return acc;
    }
    if (label.includes(q)) {
      acc.push({ ...item, isExpand: true });
      return acc;
    }
    const matched = subs.filter((sub) =>
      String(sub?.labelText || "").toLowerCase().includes(q)
    );
    if (matched.length) {
      acc.push({ ...item, isExpand: true, subMenu: matched });
    }
    return acc;
  }, []);
}
